import { defineStore } from 'pinia'
import { company } from '@/libs/api'

export const useCompany = defineStore('company', {
  state: () => ({
    id: null,
    name: null,
    type: null,
    isProcessClosing: false,
    updatedAtMs: null,

    permissions: {
      canClose: false,
    },
    documents: null,
  }),
  actions: {
    init() {
      return company.getInfo().then(({ data }) => {
        this.id = data.id
        this.name = data.name
        this.type = data.type
        this.isProcessClosing = data.is_process_closing
        this.permissions = data.permissions
        this.updatedAtMs = data.updatedAtMs
        this.documents = data.documents
      })
    },
  },
})
